module.exports = __webpack_public_path__ + "media/images/caregiver/caregiver_avatar_03-35044f3e97c80591a57d5a3ae1301235.png";